import { COLORS } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30rem;
`;

export const ProductsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  background-color: ${COLORS.WHITE};
  padding: 30rem;
  border-radius: 10rem;
`;

export const ProductsTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 25rem;
`;

export const ProductsTitle = styled.span`
  font-size: 30rem;
  font-weight: 400;
  color: ${COLORS.BLACK};
`;

export const SupplierGroupWrapper = styled.div<{ $isOdd: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 15rem;
  margin-bottom: 25rem;
  padding: 20rem;
  border: 1rem solid ${COLORS.BORDER};
  border-radius: 10rem;
  background-color: ${(props: { $isOdd: boolean }) =>
    props.$isOdd ? COLORS.BACKGROUND : COLORS.WHITE};
`;

export const SupplierGroupTitle = styled.span`
  font-size: 25rem;
  font-weight: bold;
  color: ${COLORS.GREEN};
  display: block;
  padding-bottom: 12rem;
  border-bottom: 1rem solid ${COLORS.BORDER};
`;

export const NoContentLabel = styled.label`
  text-align: center;
  font-weight: 300;
  font-size: 18rem;
  line-height: 27rem;
  color: ${COLORS.BLACK};

  ${respondTo.bigPhone`
    font-size: 16rem;
  `}
`;

export const LoaderWrapper = styled.div`
  display: flex;
  margin-top: 30rem;
`;

export const PricingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5rem;
  align-items: flex-end;
  margin-left: auto;
`;

export const PricingRow = styled.div`
  display: flex;
  gap: 20rem;

  ${respondTo.bigPhone`
    width: 100%;
    justify-content: space-between;
  `}
`;

export const PricingLabel = styled.span`
  font-size: 22rem;
  font-weight: 400;
  color: ${COLORS.BLACK};
  display: block;

  ${respondTo.smallTablet`
    font-size: 20rem;
  `}
`;

export const PricingValue = styled.span`
  font-size: 22rem;
  font-weight: 400;
  color: ${COLORS.BLACK};
  display: block;
  width: 200rem;
  text-align: right;

  ${respondTo.smallTablet`
    font-size: 20rem;
  `}

  ${respondTo.bigPhone`
    width: auto;
  `}
`;

export const PricingRowTotal = styled(PricingRow)`
  border-top: 1px solid ${COLORS.BLACK};
  padding-top: 10rem;
  margin-top: 10rem;
`;

export const PricingValueTotal = styled(PricingValue)`
  color: ${COLORS.GREEN};
  font-weight: bold;
`;

export const BottomWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  ${respondTo.midTablet`
    flex-direction: column;
    gap: 20rem;
    align-items: flex-end;
  `}
`;

export const AdditionalCartDetailsWrapper = styled.div`
  max-width: 50%;
  width: 100%;

  ${respondTo.midTablet`
    max-width: 100%;
  `}
`;

export const AdditionalCartDetailsTitle = styled.span`
  font-size: 20rem;
  font-weight: bold;
  color: ${COLORS.BLACK};
  display: block;
`;

export const AdditionalCartDetailsContent = styled.span`
  font-size: 18rem;
  font-weight: 300;
  color: ${COLORS.BLACK};
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: anywhere;
  word-break: break-word;
  margin-top: 10rem;
`;
